var React = require('react');

function MobileNav (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Mobile-Navigation-Closed"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","key":1},React.createElement("g",{"id":"BBV---Mobile---Navigation","transform":"translate(-319.000000, -39.000000)","stroke":"currentColor","strokeWidth":"3"},React.createElement("g",{"id":"Mobile-Navigation-Closed","transform":"translate(321.000000, 40.000000)"},[React.createElement("line",{"x1":"0","y1":"0.5","x2":"24","y2":"0.5","id":"Line-6","key":0}),React.createElement("line",{"x1":"0","y1":"7.5","x2":"24","y2":"7.5","id":"Line-6","key":1}),React.createElement("line",{"x1":"0","y1":"14.5","x2":"24","y2":"14.5","id":"Line-6","key":2})])))]);
}

MobileNav.defaultProps = {"width":"28px","height":"17px","viewBox":"0 0 28 17","version":"1.1"};

module.exports = MobileNav;

MobileNav.default = MobileNav;
